import { RootState } from "../reducers";
import {
  ClassificationParameter,
  ClassificationSegmentValues,
  ClassificationValues,
} from "../../interfaces/classification";
import { ParameterValueWithSymbol } from "../../interfaces/style";
import { ClassificationValueUpdate } from "./classification";

export const getClassificationValues = ({ classification }: RootState): ClassificationValues =>
  classification && classification.present.values;

export const getClassificationSegments = ({ classification }: RootState): ClassificationSegmentValues =>
  classification && classification.present.segments;

export const getPrevClassificationValues = ({ classification }: RootState): ClassificationValues =>
  classification && classification.past.length ? classification.past[classification.past.length - 1].values : undefined;

export const getClassificationClassesCount = ({ classification }: RootState): number =>
  classification && classification.present.values ? classification.present.values.length : 0;

export const getClassificationField = ({ classification }: RootState): ClassificationValueUpdate["field"] =>
  (classification && classification.present.field) || undefined;

export const getClassificationParameter = ({ classification }: RootState): ClassificationParameter =>
  (classification && classification.present.parameter) || undefined;

export const getClassificationDefaultValue = ({ classification }: RootState): ParameterValueWithSymbol =>
  classification && classification.present.defaultValue;

export const getClassificationDefaultTitle = ({ classification }: RootState): string =>
  classification && classification.present.defaultTitle;

export const getClassificationError = ({ classification }: RootState): string =>
  classification && classification.present.error;

export const getUndoRedoClassification = ({ classification }: RootState): { canUndo: boolean; canRedo: boolean } => ({
  canUndo: classification.past.length > 0,
  canRedo: classification.future.length > 0,
});
